import axios from '../localAxios';
import { postRoomShareCodeURL } from './roomsURLs';

export interface CreateRoomShareLinkResponse {
  url: string;
}

export interface CreateRoomShareLinkParams {
  roomName: string;
  roomId: number;
}

export async function createRoomShareLink({
  roomName,
  roomId,
}: CreateRoomShareLinkParams) {
  const url = postRoomShareCodeURL();
  const response = await axios.post<CreateRoomShareLinkResponse>(url.href, {
    room_name: roomName,
  });
  return { ...response.data, name: roomName, id: roomId };
}
